/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import React, { useState, useEffect } from "react";
import { Container, Col } from "react-bootstrap";
import htmlParser from "html-react-parser";
import "./BodyV2.css";

export default function BodyV2({ bannerData }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const isDesktop = windowWidth > 991;

  const bannerBackgroundDesktop = bannerData?.bannerBackgroundDesktop || "";
  const bannerBackgroundMobile = bannerData?.bannerBackgroundMobile || "";
  const bannerBackgroundColorDesktop = bannerData?.bannerBackgroundColorDesktop || "";
  const bannerBackgroundColorMobile = bannerData?.bannerBackgroundColorMobile || "";

  const bannerBackgroundColor = isDesktop ? bannerBackgroundColorDesktop : bannerBackgroundColorMobile;
  const backgroundImage = isDesktop ? bannerBackgroundDesktop : bannerBackgroundMobile;

  const imageGrid = isDesktop ? bannerData?.bannerImageGridDesktop : bannerData?.bannerImageGridMobile;
  const stripImage = isDesktop ? bannerData?.bannerStripDesktop : bannerData?.bannerStripMobile;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="banner banner-v2"
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
        backgroundColor: bannerBackgroundColor || undefined,
      }}
    >
      {backgroundImage && (
        <img src={backgroundImage} alt="" fetchPriority="high" loading="eager" style={{ display: 'none' }} />
      )}
      {/* Desktop */}
      <div className="banner-v2-desktop">
        <div className="banner-v2-grid">
          {/* Area: text */}
          <div className="banner-v2-text">
            <p className="mastermind">{htmlParser(bannerData.mastermindbannerheading)}</p>
            <p className="bannertextsub">{htmlParser(bannerData.mastermindsubheading1)}</p>
            <p className="bannertextsubpara">{htmlParser(bannerData.mastermindsubheading2)}</p>
          </div>

          {/* Area: strip */}
          <div className="banner-v2-strip">
            {stripImage && (
              <img src={stripImage} alt="" className="banner-v2-strip-img" />
            )}
            <p className="banner-v2-strip-text">
              {htmlParser(bannerData.monthedition)}
            </p>
          </div>

          {/* Area: images */}
          {imageGrid && (
            <div className="banner-v2-images">
              <img src={imageGrid} alt="Banner images" className="banner-v2-grid-img" fetchPriority="high" loading="eager" />
            </div>
          )}
        </div>
      </div>

      {/* Mobile */}
      <div className="banner-v2-mobile">
        <Container>
          <div className="bannertextdesktop">
            <p className="mastermind">{htmlParser(bannerData.mastermindbannerheading)}</p>
          </div>
          <div className="bannertextsub">
            <p>{htmlParser(bannerData.mastermindsubheading1)}</p>
          </div>
          <div className="bannertextsubpara">
            <p>{htmlParser(bannerData.mastermindsubheading2)}</p>
          </div>
        </Container>
        <div className="mobile-explore">
          <div className="exploreandeditoinmobile d-flex">
            <Col lg={12} md={12} sm={12} xs={12}>
              <div className="edition">
                <p className="textedition">{htmlParser(bannerData.montheditionmobile)}</p>
              </div>
            </Col>
          </div>
        </div>
      </div>
    </div>
  );
}
